import Typography from '@mui/material/Typography';

interface Props {
    template: string;
    email?: string;
}

export function MicrosoftAccessNotice({ template, email }: Props) {
    if (!email) {
        return (
            <Typography color="error" variant="body2" data-testid="microsoft-access-notice" sx={{ mb: 2 }}>
                {template}
            </Typography>
        );
    }
    const [before, after = ''] = template.split('{{email}}');
    return (
        <Typography color="error" variant="body2" data-testid="microsoft-access-notice" sx={{ mb: 2 }}>
            {before}
            {email}
            {after}
        </Typography>
    );
}
